/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type SkipEventPayload = {
    eventRuleId: number;
    start: DateTime;
    end: DateTime;
    title?: string;
    eventCategoryId?: number;
    locationSelection?: SkipEventPayload.locationSelection;
};
export namespace SkipEventPayload {
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

